const ACCOUNT_REDUX_CONSTANT = {
  GET_CLIENT_INFO: 'GET_CLIENT_INFO',
  UPDATE_CLIENT_INFO: 'UPDATE_CLIENT_INFO',
  GET_INDUSTRIES: 'GET_INDUSTRIES',
  GET_COMPANY_SIZE: 'GET_COMPANY_SIZE',
  GET_INVOICES: 'GET_INVOICES',
  // CLIENT_AUTH_NOTIFICATION: 'CLIENT_AUTH_NOTIFICATION',
};
export default ACCOUNT_REDUX_CONSTANT;
